import React from "react";
import ReactDOM from "react-dom";
import {ForumThread} from "../components/ForumThread";

export const insertForumThread = () => {
  const apps = document.querySelectorAll('[data-fqxi-type="forum-thread"]');

  if (apps.length === 0) {
    return;
  }

  apps.forEach((element) => {
    ReactDOM.render(<ForumThread />, element);
  });
};
